import { render, staticRenderFns } from "./CustomerNav.vue?vue&type=template&id=f21a1d16&scoped=true&"
import script from "./CustomerNav.vue?vue&type=script&lang=js&"
export * from "./CustomerNav.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNav.vue?vue&type=style&index=0&id=f21a1d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21a1d16",
  null
  
)

export default component.exports